import { render, staticRenderFns } from "./GuardianClient.vue?vue&type=template&id=5a56d940&"
import script from "./GuardianClient.vue?vue&type=script&lang=js&"
export * from "./GuardianClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports